import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as Happy } from 'icons/Emotions/Happy.svg';
import { ReactComponent as Angry } from 'icons/Emotions/Angry.svg';
import { ReactComponent as Neutral } from 'icons/Emotions/Neutral.svg';
import { ReactComponent as Wow } from 'icons/Emotions/Wow.svg';
import { ReactComponent as Sad } from 'icons/Emotions/Sad.svg';

import Slider from './RangeSlider';
import Handle from './RangeHandle';

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

class Gradient extends React.PureComponent {
  state = {
    limit: 0,
    grab: 0,
    width: 0,
  }

  componentDidMount() {
    this.update();
  }

  get emotion() {
    switch (this.props.value) {
      case 0:
        return <Angry />;
      case 1:
        return <Sad />;
      case 2:
        return <Neutral />;
      case 3:
        return <Wow />;
      case 4:
        return <Happy />;
      default:
        return <Neutral />;
    }
  }

  get coordinate() {
    const position = this.getPositionFromValue(this.props.value);

    const value = this.getValueFromPosition(position);
    return this.getPositionFromValue(value);
  }

  update = () => {
    if (!this.slider) return;

    const handlePosition = this.handle.offsetWidth;

    this.setState({
      limit: this.slider.offsetWidth - handlePosition,
      grab: handlePosition / 2,
      width: this.slider.offsetWidth,
      handleWidth: this.handle.offsetWidth,
    });
  };

  handleStart = () => {
    document.addEventListener('mousemove', this.handleDrag);
    document.addEventListener('mouseup', this.handleEnd);
  };

  handleDrag = (e) => {
    e.stopPropagation();

    const value = this.position(e);

    this.props.onChange(value);
  };

  handleEnd = () => {
    document.removeEventListener('mousemove', this.handleDrag);
    document.removeEventListener('mouseup', this.handleEnd);
  };

  handleKeyDown = (e) => {
    e.preventDefault();
    const { value, min, max, step } = this.props;
    let sliderValue;

    switch (e.keyCode) {
      case 38:
      case 39:
        sliderValue = value + step > max ? max : value + step;
        break;
      case 37:
      case 40:
        sliderValue = value - step < min ? min : value - step;
        break;
      default:
        return;
    }

    this.props.onChange(sliderValue, e);
  };

  getPositionFromValue = (value) => {
    const { min, max } = this.props;
    const diffMaxMin = max - min;
    const diffValMin = value - min;
    // Высчитываем количество долей
    const percentage = this.state.width / (diffMaxMin + 1);
    // Отступ для отцентровки handler-a внутри доли
    const offset = (percentage - this.state.handleWidth) / 2;

    return Math.round(diffValMin * percentage + offset);
  };

  getValueFromPosition = (pos) => {
    const { min, max, step } = this.props;
    const percentage = clamp(pos, 0, this.state.limit) / (this.state.limit || 1);
    const baseVal = step * Math.round(percentage * (max - min) / step);
    const value = baseVal + min;

    return clamp(value, min, max);
  };

  position = (e) => {
    const coordinate = !e.touches ? e.clientX : e.touches[0].clientX;
    const direction = this.slider.getBoundingClientRect().left;
    const pos = coordinate - direction - this.state.grab;
    return this.getValueFromPosition(pos);
  };

  render() {
    return (
      <Slider
        id={this.props.id}
        ref={(s) => { this.slider = s; }}
        onMouseDown={this.handleDrag}
        onMouseUp={this.handleEnd}
        onTouchStart={this.handleStart}
        onTouchEnd={this.handleEnd}
        aria-valuemin={this.props.min}
        aria-valuemax={this.props.max}
        aria-valuenow={this.props.value}
      >
        <Handle
          ref={(sh) => { this.handle = sh; }}
          role="button"
          onMouseDown={this.handleStart}
          onTouchMove={this.handleDrag}
          onTouchEnd={this.handleEnd}
          onKeyDown={this.handleKeyDown}
          style={{ transform: `translateX(${this.coordinate}px)` }}
          tabIndex={0}
          disabled={this.props.disabled}
        >
          {this.emotion}
        </Handle>
      </Slider>
    );
  }
}

Gradient.propTypes = {
  id: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Gradient.defaultProps = {
  id: undefined,
  min: 0,
  max: 5,
  step: 1,
  value: 0,
  onChange: () => {},
  disabled: false,
};


export default Gradient;
